let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("56D7D")).then(() => parcelRequire('7dsYV'));